export default __webpack_public_path__ + "static/media/VerificativaIcon.41a9c276.svg";